import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { authReducer } from "./auth.slice";
import { loadingReducer } from "./loading.slice";
import { serverErrorReducer } from "./server-error.slice";

const reducers = {
  auth: authReducer,
  loading: loadingReducer,
  serverError: serverErrorReducer,
};
let localStore: any;

export const createStore = (
  persistKey = "cofolp",
  customReducers: any = {}
) => {
  localStore = configureStore({
    reducer: persistReducer(
      { key: persistKey, storage },
      combineReducers({ ...reducers, ...customReducers })
    ),
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
        thunk: true,
      }),
  });
  return localStore;
};

export const getReduxStore = () => localStore;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof localStore.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof localStore.dispatch;
export const persistor = (store: any) => persistStore(store);
